<template>
    <div class="zj_warp warp">
        <div class="widget_title">
            <span @click="routerPath" class="router_tag">···</span>
            <div class="cont_text_overflow">{{title}}</div>
            <slot name="warp_header"></slot>
        </div>
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props:{
            title:{
                type:String
            },
            router:{
                type:String
            }
        },
        data(){
            return {
               
            }
        },
        methods: {
            routerPath(){
                if(this.router)
                  this.$irouter({name:this.router});
            }
        }
    }
</script>
<style lang="less" scoped>
    .warp{
        position: relative;
        padding: 20px 0;
    }
    .widget_title{
        line-height: 20px;
        font-size: 16px;
        padding-right: 20px;
        &>span{
            float: right;
            color:#c7cbd4;
            letter-spacing: 2px;
            font-weight: bold;
            font-size: 14px;
        }
        .cont_text_overflow{
            margin-right: 30px;
            background: url(../img/zj_widget/warp_tit.png) no-repeat;
            background-size: 100% 100%;
            color: #fff;
            padding: 0 20px 0 15px;
            line-height: 20px;
            display: inline-block;
            span{
                margin-right:10px;
                cursor:pointer;
            }
            span:hover{
                color: #4183fc;
            }
            .is_active{
                color: #4183fc;
            }
        }
        .router_tag{
            cursor: pointer;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/zj_warp.vue